import CabinetBonuses from './CabinetBonuses'

export default function install(Vue) {
  Vue.component('CabinetBonuses', CabinetBonuses)
}
